const listItemStyle = {
    listStyle: "none",
    position: "relative",
    paddingLeft: "25px",
    color: "#6E6E6E",
    fontWeight: 600
  };

  const bulletStyle = {
    position: "absolute",
    left: "0",
    top: "0",
    fontSize: "18px",
    fontWeight: "bold",
  };

  export { listItemStyle, bulletStyle };
